import { render, staticRenderFns } from "./booksTableItem.vue?vue&type=template&id=73f76704"
import script from "./booksTableItem.vue?vue&type=script&lang=js"
export * from "./booksTableItem.vue?vue&type=script&lang=js"
import style0 from "./booksTableItem.vue?vue&type=style&index=0&id=73f76704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports